import React from 'react';
import useInView from './useInView';
import useMotionPrefs from './useMotionPrefs';

/* ==================================================================
   Reveal
   ------------------------------------------------------------------
   The single entrance primitive. It only flips a data attribute; the
   transition itself lives in motion.css, so a hundred reveals cost
   one attribute write each and nothing on the React render path.

     <Reveal delay={80}>…</Reveal>          slides up 10px + fades
     <Reveal variant="fade">…</Reveal>      fade only
   ================================================================== */

export default function Reveal({
  as: Tag = 'div',
  variant = 'up',
  delay = 0,
  threshold,
  rootMargin,
  className = '',
  style,
  children,
  ...rest
}) {
  const { reduced } = useMotionPrefs();
  const [ref, inView] = useInView({ threshold, rootMargin, skip: reduced });

  return (
    <Tag
      ref={ref}
      className={`ui-reveal ui-reveal--${variant} ${className}`.trim()}
      data-in={inView ? 'true' : 'false'}
      style={delay ? { ...style, '--ui-delay': `${delay}ms` } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
